module.exports = __webpack_public_path__ + "img/06-04-01-01.ff4454f2.png";